import api from "./api";

// Listar todos os usuários (admin)
export const listUsers = () => api.get("/users");

// Criar usuário
export const createUser = ({ username, email, password, is_admin = 0 }) =>
  api.post("/users", { username, email, password, is_admin });

// Excluir usuário
export const deleteUser = (id) => api.delete(`/users/${id}`);

// Editar usuário (admin ou dono)
export const updateUser = (id, { username, email, is_admin }) =>
  api.put(`/users/${id}`, { username, email, is_admin });

// Redefinir senha (admin para qualquer usuário)
export const adminResetPassword = (id, newPassword) =>
  api.post(`/users/${id}/password`, { newPassword });

// Redefinir senha do próprio usuário
export const resetMyPassword = (current, newPassword) =>
  api.post(`/me/password`, { current, newPassword });

// Perfil do usuário logado
export const getProfile = () => api.get("/me");

